import DatabaseModel from './DatabaseModel.js';

var TutorIa = Object.create(DatabaseModel);

TutorIa.model = 'ai/tutor-ia';

TutorIa.chat = function(params) {
    var self = this;
    params = params || {};
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/chat',
        method: 'POST',
        data: params.data || {}
    }, false);
};

export default TutorIa;
